import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
            o = it;
        var i = 0;
        var F = function F() { };
        return { s: F, n: function n() { if (i >= o.length)
                return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try {
        if (!normalCompletion && it.return != null)
            it.return();
    }
    finally {
        if (didErr)
            throw err;
    } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "@root/store";
import { getAuth } from "firebase/auth";
import { uploadBytesResumable } from "firebase/storage";
import { addDoc, collection, doc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { getFirebaseTimestamp, projects, storageReference } from "@config/firestore";
import { addIndex, append, assoc, both, concat, curry, find, filter, isEmpty, last, mergeAll, not, reduce, reject, sort, path, pathOr, pipe, propEq, propOr, values } from "ramda";
import { getType as mimeLookup } from "mime";
import moment from "moment";
import { openSnackbar } from "@comp/snackbar/actions";
import { SnackbarType } from "@comp/snackbar/types";
import { rgba } from "@styles/utils";
import { useTheme } from "@emotion/react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { CsdFileIcon, OrcFileIcon, ScoFileIcon, UdoFileIcon } from "@elem/filetype-icons";
import EditIcon from "@mui/icons-material/EditTwoTone";
import DeleteIcon from "@mui/icons-material/DeleteTwoTone";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import Tooltip from "@mui/material/Tooltip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ReactComponent as DirectoryClose } from "@svgr/webpack?-svgo,+titleProp,+ref!@root/svgs/fad-close.svg";
import { ReactComponent as DirectoryOpen } from "@svgr/webpack?-svgo,+titleProp,+ref!@root/svgs/fad-open.svg";
import { ReactComponent as WaveFormIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@root/svgs/fad-waveform.svg";
import { deleteFile, renameDocument } from "../projects/actions";
import { textOrBinary } from "@comp/projects/utils";
import { tabClose, tabOpenByDocumentUid, tabOpenNonCloudDocument } from "@comp/project-editor/actions";
import { selectIsOwner, selectCurrentTabDocumentUid } from "@comp/project-editor/selectors";
import { nonCloudFiles, deleteNonCloudFiles } from "./actions";
import { useDnD } from "./context";
import * as SS from "./styles";
import FileTreeHeader from "./header";
import { selectNonCloudFiles } from "./selectors";
import { jsx as ___EmotionJSX } from "@emotion/react";
var reduceIndexed = addIndex(reduce);
var RootReference = /*#__PURE__*/ React.forwardRef(function (properties, reference) {
    return ___EmotionJSX("div", _extends({
        ref: reference
    }, properties), properties.children);
});
RootReference.displayName = "FileTree";
var hopefulSorting = curry(function (documentIndex, documentA, documentB) {
    var indexA = path([documentA.documentUid, "index"], documentIndex);
    var indexB = path([documentB.documentUid, "index"], documentIndex);
    if (indexA && indexB) {
        return indexA < indexB ? -1 : indexA > indexB ? 1 : 0;
    }
    else {
        return documentA.filename < documentB.filename ? -1 : documentA.filename > documentB.filename ? 1 : 0;
    }
});
var humanizeBytes = function humanizeBytes(size) {
    var gb = Math.pow(1024, 3);
    var mb = Math.pow(1024, 2);
    var kb = 1024;
    if (size >= gb) {
        return Math.floor(size / gb) + " GB";
    }
    else if (size >= mb) {
        return Math.floor(size / mb) + " MB";
    }
    else if (size >= kb) {
        return Math.floor(size / kb) + " KB";
    }
    else {
        return size + " Bytes";
    }
};
function UploadNonCloudFileIcon(_ref) {
    var file = _ref.file, projectUid = _ref.projectUid, mimeType = _ref.mimeType;
    var dispatch = useDispatch();
    var _useState = useState(-1), _useState2 = _slicedToArray(_useState, 2), uploadProgress = _useState2[0], setUploadProgress = _useState2[1];
    var handleUpload = React.useCallback(function () {
        var txtOrBin = textOrBinary(file.name);
        var currentUser = getAuth().currentUser;
        var uid = currentUser ? currentUser.uid : "";
        var documentId = uuidv4();
        if (txtOrBin === "txt") {
            var utf8decoder = new TextDecoder();
            var txt = utf8decoder.decode(file.buffer);
            var document_ = {
                type: txtOrBin,
                name: file.name,
                value: txt,
                userUid: uid,
                lastModified: getFirebaseTimestamp(),
                created: getFirebaseTimestamp()
            };
            addDoc(collection(doc(projects, projectUid), "files"), document_).then(function (result) {
                var documentUid = result.id;
                dispatch(tabOpenByDocumentUid(documentUid, projectUid));
            });
        }
        else {
            var _ref2;
            var metadata = {
                contentType: (_ref2 = mimeType !== null && mimeType !== void 0 ? mimeType : mimeType) !== null && _ref2 !== void 0 ? _ref2 : txtOrBin ? "application/octet-stream" : "text/plain",
                customMetadata: {
                    filename: file.name,
                    projectUid: projectUid,
                    userUid: uid,
                    docUid: documentId
                }
            };
            storageReference("".concat(uid, "/").concat(projectUid, "/").concat(documentId)).then(function (ref) {
                var uploadTask = uploadBytesResumable(ref, file.buffer, metadata);
                uploadTask.on("state_changed", function (snapshot) {
                    var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                    setUploadProgress(progress);
                    // console.log("Upload is " + progress + "% done");
                }, function (error) {
                    console.error(error);
                    dispatch(openSnackbar(error.message, SnackbarType.Error));
                }, function () {
                    dispatch(tabClose(projectUid, file.name, false));
                    dispatch(deleteNonCloudFiles(file.name));
                    nonCloudFiles.delete(file.name);
                    setUploadProgress(-1);
                    dispatch(openSnackbar("Upload done, the file should appear in a second...", SnackbarType.Info));
                });
            });
        }
    }, [dispatch, file, projectUid, setUploadProgress, mimeType]);
    return uploadProgress > -1 ? ___EmotionJSX("div", {
        style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
            backgroundColor: "rebeccapurple",
            zIndex: 10,
            userSelect: "none",
            cursor: "initial"
        }
    }, ___EmotionJSX("div", {
        style: {
            margin: "auto",
            width: "100%",
            height: "100%",
            textAlign: "center",
            lineHeight: "35px"
        }
    }, "Upload: ".concat(uploadProgress, "%"))) : ___EmotionJSX(Tooltip, {
        placement: "right",
        title: ___EmotionJSX(React.Fragment, null, "Upload ".concat(propOr("", "name", file), " (").concat(humanizeBytes(file.buffer.length), ") to your project"), ___EmotionJSX("br", null), " ", ___EmotionJSX("small", null, "Created: ".concat(moment(file.createdAt).fromNow())))
    }, ___EmotionJSX(UploadIcon, {
        css: SS.editIcon,
        onClick: handleUpload,
        style: {
            marginRight: "6px"
        }
    }));
}
function DownloadNonCloudFileIcon(_ref3) {
    var file = _ref3.file, mimeType = _ref3.mimeType;
    var onClick = useCallback(function () {
        var blob = new Blob([file.buffer], {
            type: mimeType
        });
        var tmpUrl = URL.createObjectURL(blob);
        window.open(tmpUrl);
    }, [file, mimeType]);
    return ___EmotionJSX(Tooltip, {
        placement: "right",
        title: ___EmotionJSX(React.Fragment, null, "Download ".concat(propOr("", "name", file), " (").concat(humanizeBytes(file.buffer.length), ")"), ___EmotionJSX("br", null), " ", ___EmotionJSX("small", null, "Created: ".concat(moment(file.createdAt).fromNow())))
    }, ___EmotionJSX(DownloadIcon, {
        css: SS.editIcon,
        onClick: onClick
    }));
}
function FileExtIcon(_ref4) {
    var isBinary = _ref4.isBinary, filename = _ref4.filename, _ref4$nestingDepth = _ref4.nestingDepth, nestingDepth = _ref4$nestingDepth === void 0 ? 0 : _ref4$nestingDepth;
    if (isBinary) {
        return ___EmotionJSX(ListItemIcon, {
            css: SS.listItemIcon,
            style: {
                left: 6,
                marginLeft: 24 * nestingDepth
            }
        }, ___EmotionJSX(WaveFormIcon, {
            css: SS.mediaIcon
        }));
    }
    return filename.endsWith(".csd") || filename.endsWith(".sco") || filename.endsWith(".orc") || filename.endsWith(".udo") ? ___EmotionJSX(ListItemIcon, {
        css: SS.listItemIconMui,
        style: {
            left: 6,
            marginLeft: 24 * nestingDepth
        }
    }, ___EmotionJSX("span", {
        css: SS.csoundFileIcon
    }, filename.endsWith(".csd") ? ___EmotionJSX(CsdFileIcon, null) : filename.endsWith(".orc") ? ___EmotionJSX(OrcFileIcon, null) : filename.endsWith(".sco") ? ___EmotionJSX(ScoFileIcon, null) : filename.endsWith(".udo") ? ___EmotionJSX(UdoFileIcon, null) : ___EmotionJSX(CsdFileIcon, null))) : ___EmotionJSX(ListItemIcon, {
        css: SS.listItemIconMui,
        style: {
            left: 0,
            marginLeft: 24 * nestingDepth
        }
    }, ___EmotionJSX(InsertDriveFileIcon, {
        css: SS.muiIcon
    }));
}
var makeTree = function makeTree(activeProjectUid, currentTabDocumentUid, dispatch, collapseState, setCollapseState, isOwner, theme, path, _ref5, filelist) {
    var _ref6 = _slicedToArray(_ref5, 2), documentIndex = _ref6[0], elementArray = _ref6[1];
    var allDirectories = filter(propEq("type", "folder"), filelist);
    var allFiles = filter(function (f) {
        return not(propEq("type", "folder", f));
    }, filelist);
    var dragHoverCss = "{background-color: rgba(".concat(rgba(theme.allowed, 0.1), ") !important;}");
    // this could be problematic, but then again, we need to test what behaviour we want
    var sortedFiles = concat(sort(hopefulSorting(documentIndex), allDirectories), sort(hopefulSorting(documentIndex), allFiles));
    var currentFiles = filter(propEq("path", path || []), sortedFiles);
    var newFileList = reject(both(propEq("path", path || []), function (p) {
        return not(propEq("type", "folder", p));
    }), sortedFiles);
    var folderDocument = !isEmpty(path) && find(propEq("documentUid", last(path)), sortedFiles);
    var folderClassName = "folder-".concat(folderDocument ? folderDocument.documentUid : "root");
    var deleteIcon = function deleteIcon(document_) {
        return isOwner && ___EmotionJSX(Tooltip, {
            placement: "right",
            title: "Delete ".concat(propOr("", "filename", document_))
        }, ___EmotionJSX(DeleteIcon, {
            color: "secondary",
            css: SS.deleteIcon,
            onClick: function onClick() {
                return dispatch(deleteFile(activeProjectUid, document_.documentUid));
            }
        }));
    };
    var editIcon = function editIcon(document_) {
        return isOwner && ___EmotionJSX(Tooltip, {
            placement: "right",
            title: "Rename ".concat(propOr("", "filename", document_))
        }, ___EmotionJSX(EditIcon, {
            css: SS.editIcon,
            onClick: function onClick() {
                return dispatch(renameDocument(activeProjectUid, document_.documentUid));
            }
        }));
    };
    return reduceIndexed(function (_ref7, document_, index) {
        var _ref8 = _slicedToArray(_ref7, 2), documentIndex_ = _ref8[0], elementArray_ = _ref8[1];
        if (propEq("type", "folder", document_)) {
            var folderPath = append(document_.documentUid, document_.path);
            var FolderIcon = ___EmotionJSX(ListItemIcon, {
                key: "".concat(document_.documentUid, "-folder"),
                css: SS.listItemIcon,
                style: {
                    left: 1 + (24 * path.length - 1)
                }
            }, collapseState[document_.documentUid] ? ___EmotionJSX(DirectoryOpen, {
                css: SS.directoryOpenIcon
            }) : ___EmotionJSX(DirectoryClose, {
                css: SS.directoryCloseIcon
            }));
            var _makeTree = makeTree(activeProjectUid, currentTabDocumentUid, dispatch, collapseState, setCollapseState, isOwner, theme, folderPath, [documentIndex_, []], newFileList), _makeTree2 = _slicedToArray(_makeTree, 2), newDocumentIndex = _makeTree2[0], newElementArray = _makeTree2[1];
            return [assoc(document_.documentUid, {
                    index: index,
                    parent: folderDocument ? folderDocument.documentUid : "root"
                }, newDocumentIndex), pipe(append(___EmotionJSX(Droppable, {
                    key: "".concat(document_.documentUid),
                    droppableId: "".concat(document_.documentUid),
                    direction: "vertical",
                    mode: "standard"
                }, function (droppableProvided, droppableSnapshot) {
                    return ___EmotionJSX(RootReference, {
                        ref: droppableProvided.innerRef
                    }, ___EmotionJSX(Draggable, {
                        isDragDisabled: !isOwner,
                        draggableId: "".concat(document_.documentUid),
                        index: index
                    }, function (provided, snapshot) {
                        return ___EmotionJSX(ListItem, _extends({
                            ref: provided.innerRef,
                            css: droppableSnapshot.isDraggingOver ? SS.draggingOver : SS.listItem,
                            onClick: function onClick() {
                                return setCollapseState(assoc(document_.documentUid, not(collapseState[document_.documentUid]), collapseState));
                            },
                            className: "folder-".concat(document_.documentUid)
                        }, provided.draggableProps, provided.dragHandleProps, {
                            style: mergeAll([snapshot.isDragging ? provided.draggableProps.style : {}, {
                                    paddingLeft: 40,
                                    height: 36
                                }])
                        }), FolderIcon, ___EmotionJSX(Box, {
                            marginLeft: "24px",
                            padding: "0"
                        }, document_.filename), ___EmotionJSX("div", {
                            css: SS.delEditContainer
                        }, deleteIcon(document_), editIcon(document_)));
                    }), ___EmotionJSX(Collapse, {
                        timeout: {
                            enter: 300,
                            exit: 200
                        },
                        in: collapseState[document_.documentUid],
                        key: "".concat(document_.documentUid, "-collapse")
                    }, newElementArray, ___EmotionJSX("span", {
                        className: "folder-".concat(document_.documentUid)
                    }, droppableProvided.placeholder)));
                })))(elementArray_)];
        }
        else {
            return [assoc(document_.documentUid, {
                    index: index,
                    parent: folderDocument ? folderDocument.documentUid : "root"
                }, documentIndex_), append(___EmotionJSX(Droppable, {
                    droppableId: "".concat(document_.documentUid),
                    key: "".concat(document_.documentUid, "-fragment")
                }, function (droppableProvided, droppableSnapshot) {
                    return ___EmotionJSX(RootReference, {
                        ref: droppableProvided.innerRef
                    }, droppableSnapshot.isDraggingOver && ___EmotionJSX("style", null, ".".concat(folderClassName, " > span.MuiTouchRipple-root") + dragHoverCss), ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Draggable, {
                        isDragDisabled: !isOwner,
                        draggableId: "".concat(document_.documentUid),
                        index: index
                    }, function (provided, snapshot) {
                        return ___EmotionJSX(ListItem, _extends({
                            key: document_.documentUid,
                            ref: provided.innerRef,
                            css: SS.listItem,
                            className: folderClassName
                        }, provided.draggableProps, provided.dragHandleProps, {
                            onClick: function onClick() {
                                return dispatch(tabOpenByDocumentUid(document_.documentUid, activeProjectUid));
                            },
                            sx: {
                                paddingLeft: 40 + 24 * path.length + "px !important"
                            },
                            style: mergeAll([snapshot.isDragging ? mergeAll([provided.draggableProps.style, {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)"
                                    }]) : {}, {
                                    height: 36,
                                    backgroundColor: currentTabDocumentUid === document_.documentUid ? "rgba(0,0,0,0.2)" : "inherit"
                                }])
                        }), ___EmotionJSX(FileExtIcon, {
                            nestingDepth: path.length,
                            isBinary: document_.type === "bin",
                            filename: document_.filename
                        }), ___EmotionJSX("p", {
                            css: SS.filenameStyle
                        }, document_.filename), ___EmotionJSX(Box, {
                            css: SS.delEditContainer
                        }, deleteIcon(document_), editIcon(document_)));
                    })), droppableProvided.placeholder);
                }), elementArray_)];
        }
    }, [documentIndex, elementArray], currentFiles);
};
var FileTree = function FileTree() {
    var _useState3 = useState({}), _useState4 = _slicedToArray(_useState3, 2), collapseState = _useState4[0], setCollapseState = _useState4[1];
    // const [isLoaded, setIsLoaded] = useState(false);
    var _useDnD = useDnD(), _useDnD2 = _slicedToArray(_useDnD, 1), stateDnD = _useDnD2[0];
    var dispatch = useDispatch();
    var theme = useTheme();
    var activeProjectUid = useSelector(pathOr("", ["ProjectsReducer", "activeProjectUid"]));
    var nonCloudFileTreeEntries = useSelector(selectNonCloudFiles);
    var nonCloudFileSources = [];
    var _iterator = _createForOfIteratorHelper(nonCloudFileTreeEntries), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var ncfEntry = _step.value;
            if (nonCloudFiles.has(ncfEntry)) {
                nonCloudFileSources.push(nonCloudFiles.get(ncfEntry));
            }
        }
        // console.log({ nonCloudFileSources, nonCloudFileTreeEntries });
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
    var isOwner = useSelector(selectIsOwner(activeProjectUid));
    var project = useSelector(path(["ProjectsReducer", "projects", activeProjectUid]));
    var documents = useSelector(path(["ProjectsReducer", "projects", activeProjectUid, "documents"]));
    var currentTabDocumentUid = useSelector(selectCurrentTabDocumentUid);
    var filelist = values(documents || {});
    return ___EmotionJSX(React.Fragment, null, stateDnD && project && ___EmotionJSX("div", {
        css: SS.container
    }, ___EmotionJSX(List, {
        css: SS.listContainer,
        dense: true
    }, makeTree(activeProjectUid, currentTabDocumentUid, dispatch, collapseState, setCollapseState, isOwner, theme, [], [stateDnD.docIdx, []], filelist)[1], nonCloudFileSources.length > 0 && ___EmotionJSX("hr", null), nonCloudFileSources.map(function (file, index) {
        var mimeType = mimeLookup(file.name);
        return ___EmotionJSX("div", {
            key: file.name + index,
            style: {
                paddingLeft: "6px",
                cursor: "pointer"
            }
        }, ___EmotionJSX(ListItem, {
            onClick: function onClick() {
                return dispatch(tabOpenNonCloudDocument(file.name, mimeType));
            },
            css: SS.listItem,
            style: {
                position: "relative",
                height: "42px"
            }
        }, ___EmotionJSX(FileExtIcon, {
            filename: file.name,
            isBinary: mimeType.startsWith("audio"),
            nestingDepth: 0
        }), ___EmotionJSX("p", {
            css: SS.filenameStyle,
            style: {
                marginLeft: "16px",
                marginRight: "8px"
            }
        }, file.name), ___EmotionJSX(Box, {
            display: "flex",
            justifyContent: "space-between"
        }, ___EmotionJSX(UploadNonCloudFileIcon, {
            file: file,
            mimeType: mimeType,
            projectUid: activeProjectUid
        }), ___EmotionJSX(DownloadNonCloudFileIcon, {
            file: file,
            mimeType: mimeType
        }))));
    })), ___EmotionJSX(FileTreeHeader, {
        isOwner: isOwner,
        project: project
    })));
};
export default FileTree;
